import { COLORS } from "components";

// TextField / DatePicker inputs
export const detailInputSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        fontSize: '14px',
        '& fieldset': { borderColor: COLORS.GREY_BORDER },
        '&:hover fieldset': { borderColor: COLORS.GREY_BORDER },
        '&.Mui-focused fieldset': { borderColor: COLORS.GREY_BORDER, borderWidth: '1px' },
    },
    '& .MuiInputBase-input::placeholder': {
        color: COLORS.Mainblue,
        margin: '0',
        opacity: 0.4,
        fontSize: '12px',
        fontWeight: '500',
        fontStyle: 'italic',
    },
};

// EsgSingleSelectControlledField / CustomDropdownField — passed as sxSelect
export const detailDropdownSxSelect = {
    '& .MuiOutlinedInput-root': {
        '& fieldset': { borderColor: COLORS.GREY_BORDER },
        '&:hover fieldset': { borderColor: COLORS.GREY_BORDER },
        '&.Mui-focused fieldset': { borderColor: COLORS.GREY_BORDER, borderWidth: '1px' },
    },
};

// MUI Select (LevelEntityField) — applied on the wrapper Box
export const detailSelectWrapperSx = {
    '& .MuiOutlinedInput-notchedOutline': { borderColor: `${COLORS.GREY_BORDER} !important` },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: `${COLORS.GREY_BORDER} !important` },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: `${COLORS.GREY_BORDER} !important`, borderWidth: '1px !important' },
};

// EsgMultiselectControlledField — applied on the wrapper Box
export const detailMultiSelectSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px !important',
        fontSize: '14px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${COLORS.GREY_BORDER} !important`,
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: `${COLORS.GREY_BORDER} !important`,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${COLORS.GREY_BORDER} !important`,
        borderWidth: '1px !important',
    },
    '& .MuiFormLabel-root': {
        fontSize: '12px',
        fontWeight: 600,
        color: 'black',
    },
};
